import SecuritySettings from '../components/dashboard/SecuritySettings';

export default function SecurityPage() {
  return <SecuritySettings />;
}
